import { DictGeoOutputSchema as o, DictOSTypeOutputSchema as t, DictAdUnitTypesOutputSchema as s, DictDeviceSchema as r, DictBrowserSchema as c, DictCategorySchema as i, DictLanguageOutputSchema as m, DictDealTypeOutputSchema as y, DictContentTypeOutputSchema as d, CpaAutoRuleIdSchema as l, DictBlacklistStatusSchema as p, DictBlacklistBanTypeSchema as S, DictBlacklistConditionParamSchema as h, UserIdSchema as a } from "@hprofits/shared";
import { z as e } from "zod";
import { AdTagSchema as u } from "../creative-group/schemas.js";
const n = e.enum(["flat", "full"]).default("flat"), w = e.object({ mode: n }).readonly(), I = e.array(o).readonly(), M = e.object({ mode: n }).readonly(), P = e.array(t).readonly(), z = e.object({ mode: n }).readonly(), G = e.array(s).readonly(), L = e.array(r).readonly(), Q = e.array(c).readonly(), N = e.array(i).readonly(), x = e.array(m).readonly(), q = e.array(y).readonly(), E = e.array(d).readonly(), g = e.object({
  id: l,
  name: e.string()
}).readonly(), F = e.array(g).readonly(), H = e.array(p).readonly(), J = e.array(S).readonly(), K = e.array(h).readonly(), R = e.object({
  id: a,
  email: e.string()
}).readonly(), V = e.array(R).readonly(), b = e.object({
  // No branded site id exists in @hprofits/shared yet, unlike UserIdSchema above.
  id: e.int().positive(),
  name: e.string(),
  domain: e.string(),
  userId: a,
  // `sites.status_id`: 1 pending, 2 active, 3 rejected, 4 paused (no dictionary table exists).
  statusId: e.int().nullable()
}).readonly(), W = e.array(b).readonly(), D = e.object({
  id: a,
  email: e.string()
}).readonly(), X = e.array(D).readonly(), T = e.object({
  id: a,
  email: e.string(),
  hasManagerRole: e.boolean()
}).readonly(), Y = e.array(T).readonly(), A = e.object({
  id: e.int().positive(),
  name: e.string(),
  actionName: e.string().nullable()
}).readonly(), Z = e.array(A).readonly(), j = e.object({
  id: e.int().positive(),
  name: e.string()
}).readonly(), _ = e.array(j).readonly(), v = e.object({
  id: e.int().positive(),
  name: e.string()
}).readonly(), $ = e.array(v).readonly(), C = e.object({
  id: e.int().positive(),
  name: e.string()
}).readonly(), ee = e.array(C).readonly(), B = e.object({
  id: u,
  name: e.string(),
  googleCompliance: e.boolean(),
  forLandings: e.boolean(),
  forCreatives: e.boolean()
}).readonly(), ae = e.array(B).readonly(), O = e.object({
  id: e.number().int().positive(),
  width: e.number().int().positive(),
  height: e.number().int().positive()
}).readonly(), ne = e.array(O).readonly();
export {
  ae as AdTagsResponseSchema,
  R as AdUnitOwnerSchema,
  V as AdUnitOwnersResponseSchema,
  b as AdUnitSiteSchema,
  W as AdUnitSitesResponseSchema,
  z as AdUnitTypeQuerySchema,
  G as AdUnitTypeResponseSchema,
  D as AdvertiserSchema,
  X as AdvertisersResponseSchema,
  ne as BannerSizesResponseSchema,
  J as BlacklistBanTypesResponseSchema,
  K as BlacklistConditionParamsResponseSchema,
  H as BlacklistStatusesResponseSchema,
  Q as BrowserTypesResponseSchema,
  N as CategoriesResponseSchema,
  E as ContentTypeResponseSchema,
  w as CountriesQuerySchema,
  I as CountriesResponseSchema,
  g as CpaAutoRuleSchema,
  F as CpaAutoRulesResponseSchema,
  q as DealTypesResponseSchema,
  L as DeviceTypeResponseSchema,
  B as DictAdTagSchema,
  O as DictBannerSizeSchema,
  C as DspSchema,
  ee as DspsResponseSchema,
  x as LanguagesResponseSchema,
  T as ManagerSchema,
  Y as ManagersResponseSchema,
  n as NestedDictModeSchema,
  M as OsQuerySchema,
  P as OsResponseSchema,
  j as PaymentTypeSchema,
  _ as PaymentTypesResponseSchema,
  v as SspSchema,
  $ as SspsResponseSchema,
  A as UserGrantSchema,
  Z as UserGrantsResponseSchema
};
//# sourceMappingURL=schemas.js.map
